module.exports = __webpack_public_path__ + "images/company_profile/icon04-17f64e3938b68beb2d0ca061baabe27a.png";